// 빌드 시점에 주입되는 공개 환경변수.
//
// 여기서 지키는 원칙 하나: **설정 실수는 실패로 끝나야 한다.**
// 예전에는 VITE_PUBLIC_SUPABASE_URL 이 없거나 형식이 틀리면 운영 프로젝트 URL
// (하드코딩된 상수)로 조용히 넘어갔다. 그러면 개발·preview·fork·새로 만든 환경의
// 설정 누락이 "빌드 실패"가 아니라 **운영 DB 접속**으로 바뀐다. anon key 까지
// 운영 값이 들어간 환경이라면 테스트가 프로덕션을 건드린다.
//
// 그래서 URL 도 anon key 와 같은 규칙을 쓴다 — 없으면 던지고, 형식이 틀려도 던진다.
// E2E 는 .env.e2e 로 명시적인 더미 값을 주므로 이 규칙에 걸리지 않는다.

function required(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(
      `Missing environment variable: ${name}. Copy .env.example to .env and fill in the values.`
    );
  }
  return value;
}

/**
 * Supabase base URL 을 검증해 `protocol//host` 형태로 정규화한다.
 *
 * 정규화가 필요한 이유는 그대로다 — GitHub Secret 에 `/rest/v1` 같은 경로가
 * 섞여 들어온 적이 있고, 그러면 supabase-js 가 `/rest/v1/rest/v1/...` 로 부른다.
 * 다만 **못 읽는 값은 고쳐 쓰지 않고 던진다.**
 */
export function normalizeSupabaseUrl(name: string, raw: string | undefined): string {
  const value = required(name, raw);
  let u: URL;
  try {
    u = new URL(value);
  } catch {
    throw new Error(
      `Invalid ${name}: ${JSON.stringify(value)} is not a URL. `
      + 'Expected something like https://<project-ref>.supabase.co',
    );
  }
  if (u.protocol !== 'https:' && u.protocol !== 'http:') {
    throw new Error(`Invalid ${name}: expected an http(s) URL, got ${u.protocol}`);
  }
  // 경로·쿼리·해시는 버린다 — supabase-js 가 자기 경로를 붙인다.
  return `${u.protocol}//${u.host}`;
}

export const SUPABASE_URL = normalizeSupabaseUrl(
  'VITE_PUBLIC_SUPABASE_URL',
  import.meta.env.VITE_PUBLIC_SUPABASE_URL,
);

export const SUPABASE_ANON_KEY = required(
  'VITE_PUBLIC_SUPABASE_ANON_KEY',
  import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY,
);
